export default [
  {
    name: 'Polish',
    level: 'Native',
    percent: 100,
    flag: 'https://flagcdn.com/w40/pl.png',
  },
  {
    name: 'English',
    level: 'C1',
    percent: 80,
    flag: 'https://flagcdn.com/w40/us.png',
    certs: [{ level: '', link: '/certs/english-b2.pdf' }],
  },
  // {
  //   name: 'Norwegian',
  //   level: 'B1+',
  //   percent: 60,
  //   flag: 'https://flagcdn.com/w40/no.png',
  // },
  // {
  //   name: 'Icelandic',
  //   level: 'B1',
  //   percent: 50,
  //   flag: 'https://flagcdn.com/w40/is.png',
  // },
  {
    name: 'German',
    level: 'A2+',
    percent: 35,
    flag: 'https://flagcdn.com/w40/de.png',
  },
  {
    name: 'Japanese',
    level: 'A2',
    percent: 25,
    flag: 'https://flagcdn.com/w40/jp.png',
  },
  // {
  //   name: 'Croatian',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/hr.png',
  // },
  // {
  //   name: 'Russian',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/ru.png',
  // },
]
